/** Public content belongs to the main app, including during product maintenance. */
export function isContentPage(path: string): boolean {
  return (
    path === "/pricing" ||
    path === "/pricing/" ||
    path === "/faq" ||
    path === "/faq/" ||
    path === "/feature" ||
    path.startsWith("/feature/") ||
    path === "/audience" ||
    path.startsWith("/audience/") ||
    path === "/features" ||
    path.startsWith("/features/") ||
    path === "/for" ||
    path.startsWith("/for/") ||
    path === "/blog" ||
    path.startsWith("/blog/") ||
    path === "/compare" ||
    path.startsWith("/compare/") ||
    path === "/docs" ||
    path.startsWith("/docs/")
  );
}

export function isContentRequest(path: string): boolean {
  return (
    isContentPage(path) ||
    path === "/api/content/search" ||
    path === "/api/content/tree" ||
    path.startsWith("/api/content/pages/") ||
    path.startsWith("/api/content/markdown/") ||
    path === "/llms.txt" ||
    path === "/llms-full.txt"
  );
}

export function markdownUrl(slugs: string[]): string {
  return `/api/content/markdown/${slugs.map(encodeURIComponent).join("/")}`;
}
